module.exports = {
          srcSet: __webpack_public_path__ + "03f8b847c6f9c50a96743ceab9520555-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "03f8b847c6f9c50a96743ceab9520555-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "03f8b847c6f9c50a96743ceab9520555-120.png",
          toString:function(){return __webpack_public_path__ + "03f8b847c6f9c50a96743ceab9520555-120.png"},
          
          width: 120,
          height: 120
        }